import request from '../utils/request';
import getSelectedHotelId from '../../../common/selectors/getSelectedHotelIdV2';
import signOut from '../actions/signOut';
import getHistory from '../../../common/utils/getHistory';
import get from 'lodash/get';

const middleware = store =>
  function (next) {
    return async action => {
      if (!action || !action.hmsFetchConfig) {
        next(action);
        return;
      }
      const isMultipleFetchConfig = Array.isArray(action.hmsFetchConfig);
      const fetchConfig = isMultipleFetchConfig ? action.hmsFetchConfig : [action.hmsFetchConfig];
      const onSuccess = action.onSuccess;
      const onError = action.onError;

      const storeState = store.getState();

      const promises = fetchConfig.map(config => {
        const { host, body, method, headers, urlParams, queryParams = {} } = config;
        const { path } = config;
        const activeHotelId = queryParams.qid ? queryParams.qid : getSelectedHotelId(storeState);
        return request({
          host,
          urlParams,
          path,
          body,
          method,
          queryParams: { ...queryParams, qid: activeHotelId }, //TODO
          headers: { ...headers, 'x-qid': activeHotelId }
        });
      });
      try {
        const responses = await Promise.all(promises);
        if (onSuccess) {
          onSuccess({
            data: isMultipleFetchConfig ? responses : responses[0].data,
            store,
            next,
            action
          });
        }
      } catch (error) {
        if (evaluateErrorForLogout(error)) {
          const history = getHistory()
          store.dispatch(signOut({ history }));
          return;
        }
        onError({ error, store, action, next });
      }
    };
  };
export default [middleware];


const evaluateErrorForLogout = error => {
  // CASE: TOKEN MISSING
  if(get(error, 'body.Exception', '') == 'Token is missing'){
    return true;
  }
  // CASE: EXPIRED TOKEN
  if(get(error, 'status', '') == 401 || get(error, 'statusCode', '') == 401){
    return true;
  }
  return false;
}
